import type { HttpClient } from '@shared/http/http-client';
import type {
  IClientRepository,
  ClientListQuery,
} from '@domain/data-contracts/client-repository.interface';
import type { Client } from '@domain/models/client.interface';
import type { PagedResult } from '@domain/models/paging.interface';
import {
  mapClientDto,
  mapPaged,
  type ClientDto,
  type PagedDto,
} from './mapping.helper';

const BASE = '/api/clients';

export class ClientRepository implements IClientRepository {
  public constructor(private readonly http: HttpClient) {}

  public async list(query: ClientListQuery): Promise<PagedResult<Client>> {
    const response = await this.http.get<PagedDto<ClientDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapClientDto);
  }

  public async getById(id: string): Promise<Client> {
    const response = await this.http.get<ClientDto>(`${BASE}/${encodeURIComponent(id)}`);
    return mapClientDto(response.data);
  }
}

function pruneParams(query: ClientListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
